import type { Tree, Rock, DecorativeGrass, Flower } from "../types";
import {
  WORLD_W,
  WORLD_H,
  NUM_TREES,
  NUM_ROCKS,
  NUM_DECORATIVE_GRASS,
  NUM_FLOWERS,
  MAX_PLACEMENT_ATTEMPTS,
  TREE_COLLISION_RADIUS,
  ROCK_COLLISION_RADIUS,
  DECORATIVE_GRASS_COLLISION_RADIUS,
  FLOWER_COLLISION_RADIUS,
} from "../constants";
import type { PathSegment } from "./paths";
import { isValidPosition } from "./collision";

export const generateTrees = (paths: PathSegment[]): Tree[] => {
  const trees: Tree[] = [];
  for (let i = 0; i < NUM_TREES; i++) {
    let attempts = 0;
    let validPosition = false;
    let tree: Tree = { x: 0, y: 0, type: 0 };

    while (!validPosition && attempts < MAX_PLACEMENT_ATTEMPTS) {
      tree = {
        x: Math.random() * WORLD_W,
        y: Math.random() * WORLD_H,
        type: Math.random() < 0.5 ? 0 : 1, // Random tree type
      };

      if (isValidPosition(tree.x, tree.y, TREE_COLLISION_RADIUS, paths)) {
        validPosition = true;
      }

      attempts++;
    }

    if (validPosition) {
      trees.push(tree);
    }
  }
  return trees;
};

export const generateRocks = (paths: PathSegment[]): Rock[] => {
  const rocks: Rock[] = [];
  for (let i = 0; i < NUM_ROCKS; i++) {
    let attempts = 0;
    let validPosition = false;
    let rock: Rock = { x: 0, y: 0, type: 0 };

    while (!validPosition && attempts < MAX_PLACEMENT_ATTEMPTS) {
      rock = {
        x: Math.random() * WORLD_W,
        y: Math.random() * WORLD_H,
        type: Math.random() < 0.5 ? 0 : 1, // Random rock type
      };

      if (isValidPosition(rock.x, rock.y, ROCK_COLLISION_RADIUS, paths)) {
        validPosition = true;
      }

      attempts++;
    }

    if (validPosition) {
      rocks.push(rock);
    }
  }
  return rocks;
};

export const generateDecorativeGrass = (paths: PathSegment[]): DecorativeGrass[] => {
  const decorativeGrass: DecorativeGrass[] = [];
  for (let i = 0; i < NUM_DECORATIVE_GRASS; i++) {
    let attempts = 0;
    let validPosition = false;
    let grass: DecorativeGrass = { x: 0, y: 0 };

    while (!validPosition && attempts < MAX_PLACEMENT_ATTEMPTS) {
      grass = {
        x: Math.random() * WORLD_W,
        y: Math.random() * WORLD_H,
      };

      if (isValidPosition(grass.x, grass.y, DECORATIVE_GRASS_COLLISION_RADIUS, paths)) {
        validPosition = true;
      }

      attempts++;
    }

    if (validPosition) {
      decorativeGrass.push(grass);
    }
  }
  return decorativeGrass;
};

export const generateFlowers = (paths: PathSegment[]): Flower[] => {
  const flowers: Flower[] = [];
  for (let i = 0; i < NUM_FLOWERS; i++) {
    let attempts = 0;
    let validPosition = false;
    let flower: Flower = { x: 0, y: 0, type: 0 };

    while (!validPosition && attempts < MAX_PLACEMENT_ATTEMPTS) {
      flower = {
        x: Math.random() * WORLD_W,
        y: Math.random() * WORLD_H,
        type: Math.random() < 0.5 ? 0 : 1, // Random flower type
      };

      if (isValidPosition(flower.x, flower.y, FLOWER_COLLISION_RADIUS, paths)) {
        validPosition = true;
      }

      attempts++;
    }

    if (validPosition) {
      flowers.push(flower);
    }
  }
  return flowers;
};

